export default __webpack_public_path__ + "static/media/joey_tribbiani_resume.9cb88a33.png";